import React from 'react';
import DarkModeToggle from './DarkModeToggle';
import '../styles/Header.scss';

const Header: React.FC = () => {

  return (
    <header className="header">

      <div className="header__logo">
        <a href="/" aria-label="Página inicial">
          <img src="/assets/header-logo.webp" alt="Resumi Pra Ti" />
        </a>
      </div>

      <div className="header__title">
        <h1>Resumi Pra Ti</h1>
      </div>

      <div className="header__toggle">
        <DarkModeToggle />
      </div>
    </header>
  );
};

export default Header;